import Column from "@Containers/components/Column";
import React from "react";
import {useTranslation} from "@Translation/hooks/useTranslation";
import {PreparedRouteType} from "@Route/types/PreparedRoute.type";
import useIsMobile from "@Hooks/selector/useIsMobile";

type BuyTicketLabelProps = {
    route: PreparedRouteType,
    buyTextLabel?: string
}

function BuyTicketLabel({route, buyTextLabel}: BuyTicketLabelProps) {
    const label = useTranslation("search_results.buy_ticket")

    const isMobile = useIsMobile()
    const {
        travelInfo: {
            departureStation: {
                cityName: departureStationName,
            },
            destinationStation: {
                cityName: destinationStationName,
            },
        },
    } = route

    return (
        <Column center>
            <span>
                {buyTextLabel ?? label}
            </span>
            {(route.status.isSuggestion || route.status.isIntermodal) && isMobile && (
                <small>
                    {`${departureStationName} - ${destinationStationName}`}
                </small>
            )}
        </Column>
    );
}

export default BuyTicketLabel;